import { Box, Button, Col, Colors, IcClose, IcOnline, IcPlus, IcScreen, Row, Text } from 'basic-ui-lib';
import { DashboardStatItem } from 'basic-ui-lib/components/DashboardStatItem';
import useGetSummaryScreens from 'modules/dashboard/services/hooks/useGetSummaryScreens';
import { styled } from 'styled-components';

interface ScreenDashboardProps {
  onNewScreen: () => void;
}

const ScreenDashboard = ({ onNewScreen }: ScreenDashboardProps) => {
  const { summaryStats } = useGetSummaryScreens();

  return (
    <Container>
      <Row width='100%' justifyContent='space-between' alignItems='center' paddingBottom={16}>
        <Col gap={2}>
          <Text title_h2 semibold left>
            Screen Management
          </Text>
          <Text content_2 medium left>
            Manage and monitor all your connected digital displays
          </Text>
        </Col>
        <Button 
          lg 
          type_second 
          prefix={<IcPlus width={20} height={20} fill={Colors.neutral.bg[1]} />}
          onClick={onNewScreen}
        >
          New Screen
        </Button>
      </Row>
      <Box display='grid' gridTemplateColumns='repeat(3, 1fr)' gap={16}>
        <DashboardStatItem
          label='Total Screens'
          value={summaryStats?.total ?? '0'}
          icon={<IcScreen fill={Colors.primary[6]} width={32} height={32} />}
          backgroundColorIcon={Colors.primary[2]}
        />
        <DashboardStatItem
          label='Online Screens'
          value={summaryStats?.totalOnline ?? '0'}
          icon={<IcOnline fill={Colors.secondary[6]} width={32} height={32} />}
          backgroundColorIcon={Colors.secondary[1]}
        />
        <DashboardStatItem
          label='Offline Screens'
          value={summaryStats?.totalOffline ?? '0'}
          icon={<IcClose fill={Colors.other[2]} width={32} height={32} />}
          backgroundColorIcon={Colors.other[1]}
        />
      </Box>
    </Container>
  );
};

export default ScreenDashboard;

const Container = styled.div``;
